import script from "./StubContent.vue?vue&type=script&setup=true&lang=js"
export * from "./StubContent.vue?vue&type=script&setup=true&lang=js"

import "./StubContent.vue?vue&type=style&index=0&id=be97ebf4&lang=scss"

const __exports__ = script;

export default __exports__